export const EarlyRouting = [
    {
      path: "/risk-config/early/list/cost",
      name: "risk-config-early-list-cost",
      meta: { title: "项目成本预警",type:'cost' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/construction_progress",
      name: "risk-config-early-list-construction_progress",
      meta: { title: "施工进度预警",type:'construction_progress' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/progress",
      name: "risk-config-early-list-progress",
      meta: { title: "付款预警",type:'progress' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/income",
      name: "risk-config-early-list-income",
      meta: { title: "收款预警",type:'income' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/make_invoice",
      name: "risk-config-early-list-make_invoice",
      meta: { title: "开票预警",type:'make_invoice' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/income_invoice",
      name: "risk-config-early-list-income_invoice",
      meta: { title: "收票预警",type:'income_invoice' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/margin_return",
      name: "risk-config-early-list-margin_return",
      meta: { title: "保证金预警",type:'margin_return' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/maintenance",
      name: "risk-config-early-list-maintenance",
      meta: { title: "维保预警",type:'maintenance_warning' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
     {
      path: "/risk-config/early/list/tender",
      name: "risk-config-early-list-tender",
      meta: { title: "投标预警",type:'bidding' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
    {
      path: "/risk-config/early/list/rectification",
      name: "risk-config-early-list-rectification",
      meta: { title: "整改预警",type:'rectification' },
      component: () =>
        import(
          /* webpackCh`un`kName: "project-config-type" */ "@/views/risk-config/early/list/index.vue"
        ),
    },
  ];
  